// UploadStep.tsx

import React, { useState } from 'react'
import {
  Container,
  ProgressContainer,
  ProgressFill,
  FileInputDiv,
  FileInputLabel,
  FileInput,
  FileInfoDiv,
  FileInfoImg,
  FileMiddleDiv,
  FileUpperMiddleDiv,
  FileName,
  FilePercentage,
  FileInfoCancelImg,
  FileFirstText,
  FileSecondText,
} from './style'
import fileIcon from '../../../../../../assets/certificates/AddParameter/file.svg'
import cancelIcon from '../../../../../../assets/certificates/AddParameter/cancel.svg'

interface StructureFileProp {
  index: number
}

const FileInputStructure: React.FC = (props) => {
  const [tableFile, setTableFile] = useState<File | null>(null)
  const [percentage, setPercentage] = useState<string>('0')

  const handleUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files: any = e.target.files?.[0]
    setTableFile(files)
    const formData = new FormData()
    formData.append('file', files[0])
    const xhr = new XMLHttpRequest()
    xhr.upload.addEventListener('progress', (e) => ProgressHandler(e))
    xhr.open('POST', 'fileupload.php')
    xhr.send(formData)
  }

  /**O progresso é atualizado aqui, que é chamada
   * quando ocorre um evento de progresso durante o envio do arquivo.
   * Também é calculado a porcentagem */
  const ProgressHandler = (e: ProgressEvent<XMLHttpRequestEventTarget>) => {
    const percent = (e.loaded / e.total) * 100
    const newPercentage = percent.toFixed(0)
    setPercentage(newPercentage)
  }

  /**Aqui, a barra de progresso é desenhada usando um elemento <div> com a classe ProgressContainer,
   * e a largura é controlada pelo estilo inline do elemento ProgressFill, que recebe a largura correspondente
   *  ao progresso concluído, calculado em porcentagem. */

  const handleDelete = () => {
    const erasedFile = null
    const erasedPercentage = '0'
    setTableFile(erasedFile)
    setPercentage(erasedPercentage)
  }

  return (
    <Container>
      {tableFile === null ? 
        <FileInputDiv>
            <FileInputLabel htmlFor='invoice'>
                Procurar
                <FileInput 
                    type='file'
                    id='invoice'
                    name='invoice'
                    onChange={handleUpload}
                />
            </FileInputLabel>
            <FileFirstText>ou arraste um arquivo até aqui</FileFirstText>
            <FileSecondText>Apenas arquivos .pdf de no máximo 10mb</FileSecondText>
        </FileInputDiv> 
        :
        <>
        <FileInfoDiv>
            <FileInfoImg src={fileIcon} alt='File icon'/>
            <FileMiddleDiv>
                <FileUpperMiddleDiv>
                    <FileName>{tableFile.name}</FileName>
                    <FilePercentage>{percentage}%</FilePercentage>
                </FileUpperMiddleDiv>
                <ProgressContainer>
                  <ProgressFill progress={percentage} />
                </ProgressContainer>
            </FileMiddleDiv>
            <FileInfoCancelImg 
                src={cancelIcon} 
                alt='File icon'
                onClick={() => handleDelete()}
            />
        </FileInfoDiv>
        </>
      }
    </Container>
  )
}

export default FileInputStructure
